import {apiCall} from "./apicall";

export async function getCode(CardCodeID){
    return await apiCall("/codes/"+CardCodeID);
}

export async function addCode(CardID, data = {}) {
    return await apiCall("/codes", { method: "POST" }, { CardID, ...data });
}


export async function deleteCode(CardCodeID){
    return await apiCall("/codes/"+CardCodeID, {method:"DELETE"});
}

